import { useEffect, useState } from 'react';

import { matchPath, useLocation } from 'react-router-dom';

import pushRouter from 'hooks/useRouterHelper';
import Breadcrumbs from 'components/Breadcrumbs/Breadcrumbs';
import IStudyQuery from 'views/Study/components/IURLQuery';

const StudyBreadcrumbs = () => {
  const { pathname } = useLocation();
  const { query } = pushRouter<IStudyQuery>();
  const [breadcrumbs, setBreadcrumbs] = useState([]);

  useEffect(() => {
    const { params } = matchPath<{ id: string }>(pathname, '/study/:id');
    let breadcrumbs = [
      {
        title: 'Study',
        link: '/study',
      },
    ];
    if (params.id === 'form' && query?.title && query?.item && query?.subject) {
      const addBreadcrumbs = [
        {
          title: query?.title.toString(),
          link: `/study/details/${query.subject}?title=${query?.title}&lesson=${query?.item}`,
        },
        {
          title: 'Edit',
          link: '',
        },
      ];
      breadcrumbs = [...breadcrumbs, ...addBreadcrumbs];
    } else if (params.id === 'form' && query?.title && query?.subject && query?.type) {
      const addBreadcrumbs = [
        {
          title: query?.title.toString(),
          link: `/study/details/${query.subject}?title=${query?.title}`,
        },
        {
          title: `Add ${query.type}`,
          link: '',
        },
      ];
      breadcrumbs = [...breadcrumbs, ...addBreadcrumbs];
    } else if (params.id && query?.title) {
      const addBreadcrumbs = {
        title: query?.title.toString(),
        link: '',
      };
      breadcrumbs.push(addBreadcrumbs);
    }
    setBreadcrumbs(breadcrumbs);
  }, [pathname]);

  return <Breadcrumbs breadcrumbs={breadcrumbs} />;
};

export default StudyBreadcrumbs;
